import { useState, useEffect } from "react";

export const useSessionStorage = (key: string) => {
  const [sessionStorageValue, setSessionStorageValue] = useState(
    sessionStorage.getItem(key),
  );

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === key) {
        setSessionStorageValue(event.newValue);
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [key, setSessionStorageValue]);

  const setValue = (newValue: string) => {
    sessionStorage.setItem(key, newValue);
    setSessionStorageValue(newValue);
  };

  return [sessionStorageValue, setValue] as const;
};
